import React from 'react'

import { ButtonGroup } from './button-group'
import { DropdownButton } from './dropdown-button'

export const DynamicButtonGroup = function ({ children = [], ...props }) {
  if (children.length === 0) return null

  return (
    <>
      { children.length === 1
        ? children.shift()
        : (
          <ButtonGroup {...props}>
            {children.shift()}
            <DropdownButton DropdownItems={children} />
          </ButtonGroup>
        )
      }
    </>
  )
}
